import React from "react";
import { Link, useParams } from "react-router-dom";
import { caseStudies } from "../../data/caseStudies";
import PageContainer from "../container/Container";
import { FiArrowLeft } from "react-icons/fi";

function CaseStudyDetails() {
  const params = useParams();
  const id = params.id;
  const data = caseStudies.find((blog) => blog.id === parseInt(id));
  
  return (
    <PageContainer 
      title={`${data.title} - CodeElan Technologies`}
      description={data.desc}
    >
      {/* Hero Section */}
      <section className="hero-section contact-hero">
        <div className="hero-background">
          <div className="hero-overlay"></div>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-8 mx-auto text-center">
                <div className="hero-content">
                  <div className="hero-accent"></div>
                  <h1 className="hero-title">
                    {data.title}
                  </h1>
                  <p className="hero-subtitle">
                    {data.desc}
                  </p>
                  <div className="hero-actions">
                    <Link
                      to="/case-studies"
                      className="btn btn-outline-primary"
                    >
                      <FiArrowLeft className="me-2" />
                      Back to Case Studies
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Case Study Content */}
      <section className="section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="case-study-detail-content">
                {data.content}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section cta-section">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <h2 className="section-title">Ready to Start Your Success Story?</h2>
              <p className="section-subtitle">
                Let's discuss how our solutions can help you achieve similar results for your business
              </p>
              <div className="cta-buttons">
                <Link to="/contactus" className="btn btn-primary btn-lg">
                  Get In Touch
                  <FiArrowLeft className="ms-2" style={{ transform: 'rotate(180deg)' }} />
                </Link>
                <Link to="/case-studies" className="btn btn-outline-primary btn-lg ms-3">
                  View More Case Studies
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </PageContainer>
  );
}

export default CaseStudyDetails;
